import React from 'react';
import { setStoreCopy } from './adminSiteCopyFields';
import { mergeHeroActions } from '../storefrontHeroActions';

function Check({ id, label, checked, onChange }) {
  return (
    <div className="form-check">
      <input
        id={id}
        type="checkbox"
        className="form-check-input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

function Field({ id, label, value, onChange, hint }) {
  return (
    <div className="col-md-6">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      <input id={id} className="form-control" value={value} onChange={(e) => onChange(e.target.value)} />
      {hint ? <div className="form-text">{hint}</div> : null}
    </div>
  );
}

export default function AdminSiteHeroActionsFields({ form, setField }) {
  const ha = mergeHeroActions(form.store_copy?.hero_actions);
  const setHa = (patch) =>
    setStoreCopy(form, setField, {
      hero_actions: { ...ha, ...patch },
    });

  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">Hero action buttons</h2>
        <p className="small text-muted mb-0 mt-1">
          Site → Content (home &amp; about) tab. Same buttons on Home, Shop, and About. Gift finder: Shop tab.
        </p>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <Field
            id="hero-cta1-label"
            label="Primary button label"
            value={form.hero_cta1_label || ''}
            onChange={(v) => setField('hero_cta1_label', v)}
            hint="Leave blank to auto-name from fallback category."
          />
          <Field
            id="hero-cta1-url"
            label="Primary button link"
            value={form.hero_cta1_url || ''}
            onChange={(v) => setField('hero_cta1_url', v)}
            hint="e.g. /shop/rakhi"
          />
          <Field
            id="hero-cta2-label"
            label="Secondary button label"
            value={form.hero_cta2_label || ''}
            onChange={(v) => setField('hero_cta2_label', v)}
          />
          <Field
            id="hero-cta2-url"
            label="Secondary button link"
            value={form.hero_cta2_url || ''}
            onChange={(v) => setField('hero_cta2_url', v)}
            hint="e.g. /shop/lumba"
          />
          <div className="col-12">
            <label className="form-label" htmlFor="hero-fallback">
              When label or link is blank
            </label>
            <select
              id="hero-fallback"
              className="form-select"
              value={ha.fallback}
              onChange={(e) => setHa({ fallback: e.target.value })}
            >
              <option value="sort_order">Top 2 categories (catalog sort order)</option>
              <option value="rakhi_lumba">Rakhi & Lumba categories</option>
            </select>
          </div>
          <div className="col-md-6">
            <p className="small fw-semibold mb-2">Show primary button on</p>
            <Check id="hp-home" label="Home" checked={ha.show_primary_home} onChange={(v) => setHa({ show_primary_home: v })} />
            <Check id="hp-shop" label="Shop" checked={ha.show_primary_shop} onChange={(v) => setHa({ show_primary_shop: v })} />
            <Check id="hp-about" label="About" checked={ha.show_primary_about} onChange={(v) => setHa({ show_primary_about: v })} />
          </div>
          <div className="col-md-6">
            <p className="small fw-semibold mb-2">Show secondary button on</p>
            <Check
              id="hs-home"
              label="Home"
              checked={ha.show_secondary_home}
              onChange={(v) => setHa({ show_secondary_home: v })}
            />
            <Check
              id="hs-shop"
              label="Shop"
              checked={ha.show_secondary_shop}
              onChange={(v) => setHa({ show_secondary_shop: v })}
            />
            <Check
              id="hs-about"
              label="About"
              checked={ha.show_secondary_about}
              onChange={(v) => setHa({ show_secondary_about: v })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
